import { works, type Work, type WorkType } from '@/mocks/works';

export const getWorkById = (id: string): Work | undefined => works.find((w) => w.id === id);

export const getWorksByType = (type: WorkType): Work[] => works.filter((w) => w.type === type);

export const sortByUpdate = (list: Work[]): Work[] =>
  [...list].sort((a, b) => (a.updateTime < b.updateTime ? 1 : -1));

export const sortByHot = (list: Work[]): Work[] =>
  [...list].sort((a, b) => b.hot - a.hot);

export const filterWorks = (
  list: Work[],
  opts: { genre?: string; region?: string; year?: string }
): Work[] =>
  list.filter((w) => {
    if (opts.genre && opts.genre !== '全部' && !w.genres.includes(opts.genre)) return false;
    if (opts.region && opts.region !== '全部' && w.region !== opts.region) return false;
    if (opts.year && opts.year !== '全部' && String(w.year) !== opts.year) return false;
    return true;
  });

export const searchWorks = (keyword: string): Work[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return works.filter(
    (w) =>
      w.title.toLowerCase().includes(kw) ||
      w.actors.some((a) => a.toLowerCase().includes(kw)) ||
      w.director.toLowerCase().includes(kw) ||
      w.genres.some((g) => g.toLowerCase().includes(kw))
  );
};

export const getRelatedWorks = (work: Work, limit = 5): Work[] => {
  const scored = works
    .filter((w) => w.id !== work.id)
    .map((w) => {
      let score = 0;
      score += w.genres.filter((g) => work.genres.includes(g)).length * 3;
      score += w.actors.filter((a) => work.actors.includes(a)).length * 2;
      if (w.type === work.type) score += 1;
      return { w, score };
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((item) => item.w);
};

export const typeLabel = (type: WorkType): string => (type === 'tv' ? '电视剧' : '电影');